// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Core from "@material-ui/core";
import * as App_Icon$DvmAdminFrontendFr from "../../../../../common/components/icons/App_Icon.bs.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../../../intl/Intl_Utils.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../../context/user/User_Context.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../../../common/App_Typography.bs.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../../../../context/user/User_Types_Utils.bs.js";
import * as App_Styles_Common$DvmAdminFrontendFr from "../../../../../common/styles/App_Styles_Common.bs.js";

function Order_Detail_Bonus_DealerRequest_Comment(Props) {
  var dealerRequests = Props.dealerRequests;
  var actionId = Props.actionId;
  var intl = ReactIntl.useIntl();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var selectedRole = match[0].selectedRole;
  var filteredRequest;
  filteredRequest = typeof dealerRequests === "number" || dealerRequests.TAG !== /* Ok */0 ? undefined : Belt_List.getBy(dealerRequests._0, (function (x) {
            return x.actionId === Belt_Option.getWithDefault(actionId, "");
          }));
  return Belt_Option.mapWithDefault(filteredRequest, null, (function (x) {
                return React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                            style: {
                              fontWeight: "600"
                            },
                            children: React.createElement(Core.Grid, {
                                  children: null,
                                  container: true,
                                  spacing: 1
                                }, React.createElement(Core.Grid, {
                                      children: Belt_Option.mapWithDefault(x.creationDate, "", (function (param) {
                                              return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                            })) + (
                                        selectedRole !== /* Dealer */7 || !User_Types_Utils$DvmAdminFrontendFr.isAdminDealer(selectedRole) ? " - " + Belt_Option.getWithDefault(x.userId, "") : ""
                                      ),
                                      item: true
                                    }), Belt_Option.mapWithDefault(x.comment, null, (function (x) {
                                        if (x.length > 0) {
                                          return React.createElement(Core.Grid, {
                                                      children: React.createElement(Core.Tooltip, {
                                                            arrow: true,
                                                            children: React.createElement("div", undefined, React.createElement(App_Icon$DvmAdminFrontendFr.make, {
                                                                      size: /* Large */3,
                                                                      type_: /* Information */43
                                                                    })),
                                                            classes: {
                                                              tooltip: App_Styles_Common$DvmAdminFrontendFr.tooltip
                                                            },
                                                            placement: "bottom",
                                                            title: x
                                                          }),
                                                      item: true
                                                    });
                                        } else {
                                          return null;
                                        }
                                      }))),
                            variant: "body"
                          });
              }));
}

var make = Order_Detail_Bonus_DealerRequest_Comment;

export {
  make ,
}
/* react Not a pure module */
